module.exports = {"private":true,"main":"./OAuthApplication.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/pages/OAuthApplication/package.json
// module id = 850
// module chunks = 0 1